import axiosInstance from '../../../config/axiosInstance';

const  SupplierDiscountService = {
    async GetAllSupplierDiscounts(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/GetSupplierDiscount?ID=${ID}`);
           return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSupplierDiscounts(redirectCallback,ID) {
        try {            
           
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/DeleteSupplierDiscount?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default SupplierDiscountService;